import React from 'react';
import {Skeleton} from '@mui/material';
import {StyledGrid} from 'presentation/components';
import {LoadingProps} from './types';

export function Loading({isMobile}: LoadingProps) {
	return (
		<StyledGrid.Root
			p={isMobile ? 2 : 4}
			alignContent="flex-start"
			justifyContent="center"
			height="100%">
			<StyledGrid.Item key={0} sm={12} md={12} lg={8}>
				<Skeleton component="div" variant="rectangular" height={24} />
			</StyledGrid.Item>
			<StyledGrid.Item key={1} sm={12} md={12} lg={8}>
				<Skeleton component="div" variant="rectangular" height={24} />
			</StyledGrid.Item>
			<StyledGrid.Item key={2} sm={12} md={12} lg={8}>
				<Skeleton component="div" variant="rectangular" height={24} />
			</StyledGrid.Item>
		</StyledGrid.Root>
	);
}
